class CookieMessage extends HTMLElement {
  constructor() {
    super();

    this.windowWidth = window.innerWidth;
    this.init.bind(this);
    this.setSession.bind(this);
    this.getSession.bind(this);
    this.cookieScroll.bind(this);
    this.parseVisibility.bind(this);
    this.showCookieMessage.bind(this);
    this.hideCookieMessage.bind(this);

    this.showMessage = this.getSession();
    this.mainContent = document.querySelector("#MainContent");
    this.accept = this.querySelector(".cookie-message_accept");

    this.expires = this.dataset.expires;

    this.init();
  }

  init() {
    // if (document.body.classList.contains('loading') || this.mainContent.classList.contains('content-loader')) {
    //   this.cookieScroll()
    // } else {
    //   this.parseVisibility()
    // }

    const cookieExpireSet = `${this.expires}`;
    const CookieMessageCookie = "__reza-cookie_message-cookie";

    function getCookie(cname) {
      const name = cname + "=";
      const ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return "";
    }

    const setCookie = (name, value, expire = 365, path = "/") => {
      const date = new Date();
      date.setTime(date.getTime() + expire * 24 * 3600 * 1000);
      const expires = date.toUTCString();
      document.cookie = `${name}=${value}; expires=${expires}; path=${path}`;
    };

    // Define the name of the cookie.
    const cookieName = CookieMessageCookie;

    // First get the cookie..
    const cookie = getCookie(cookieName);

    // ..then check if the cookie is not set.
    if (cookie !== "show") {
      // If it isn't set, show the popup
      this.showCookieMessage();

      // ..and add the event listener to close it.
      this.accept.addEventListener("click", () => {
        setCookie(cookieName, "show", cookieExpireSet);
        this.hideCookieMessage();
      });

      // body.addEventListener("click", (event)=>{
      //   if(!(event.target).closest('.newsletter_content') && !((event.target) == ('.newsletter_content'))){
      //     setCookie(cookieName, "show", cookieExpireSet)
      //     // ..and hide the popup
      //     popup.style.display = "none"
      //     // ..and normalize the zIndex
      //     document.querySelector("#MainContent").style.zIndex = ""
      //     document.querySelector("body").style.overflow = "visible"
      //
      //   }
      // })
    }
  }

  setSession() {
    sessionStorage.setItem("cookieMessage", "false");
  }

  getSession() {
    const isSet = sessionStorage.getItem("cookieMessage");
    return isSet ? sessionStorage.getItem("cookieMessage") : "true";
  }

  parseVisibility() {
    this.showMessage === "false"
      ? this.hideCookieMessage()
      : this.showCookieMessage();

    this.accept.addEventListener("click", () => {
      this.setSession();
      this.hideCookieMessage();
    });
  }

  showCookieMessage() {
    this.style.display = "flex";

    setTimeout(() => {
      this.classList.add("fadeIn");
    }, 300);
  }

  hideCookieMessage() {
    this.classList.remove("fadeIn");
    document.querySelector("#bell") &&
      document.querySelector("#bell").classList.remove("cookie-bar");
    setTimeout(() => {
      this.style.display = "none";
    }, 450);
  }

  cookieScroll() {
    let timer = null;

    const scrollEvent = () => {
      const position = this.mainContent.offsetTop;
      const scrolledDist = document.scrollingElement.scrollTop;
      const parseVisibility = () => {
        this.parseVisibility();
      };

      if (timer !== null) {
        clearTimeout(timer);
      }

      timer = setTimeout(function () {
        if (scrolledDist >= position) {
          parseVisibility();
          document.removeEventListener("scroll", scrollEvent, false);
        }
      }, 150);
    };

    document.addEventListener("scroll", scrollEvent, false);
  }
}

customElements.define("cookie-message", CookieMessage);
